<p>terms-of-services works!</p>
